<template>
  <svg
    id="ScrollLogo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 143.98 80.61"
  >
    <title>Scroll_Logo</title>
    <path
      d="M138.64,4.35V47.77h-6.4V4.35Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M125.14,4.35V47.77h-6.41V4.35Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M28.53,27.51a4.61,4.61,0,0,0-3.92-2.36,2.71,2.71,0,0,0-2,.72,2.07,2.07,0,0,0-.59,1.44A1.75,1.75,0,0,0,23,28.88c.4.26.79.39,2.16,1.11l3.27,1.64a12.91,12.91,0,0,1,3.86,2.55,6.78,6.78,0,0,1,2,5.09,9.12,9.12,0,0,1-2.42,6.28,9.81,9.81,0,0,1-7.71,3.07,9.48,9.48,0,0,1-5.95-1.76,10.73,10.73,0,0,1-3.53-5l5.23-2.48A7.4,7.4,0,0,0,21.4,42a3.91,3.91,0,0,0,2.81,1,3.85,3.85,0,0,0,2.62-.92,3.24,3.24,0,0,0,.91-2.15,2.94,2.94,0,0,0-.85-2.09,8.12,8.12,0,0,0-2.74-1.7L21.8,35A13.27,13.27,0,0,1,18,32.67,6,6,0,0,1,16,28a8.58,8.58,0,0,1,2.29-5.88,8.86,8.86,0,0,1,6.73-2.62A8.57,8.57,0,0,1,30.16,21a9.38,9.38,0,0,1,3.14,3.4Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M60.35,28.68a10.85,10.85,0,0,0-7.78-3.4,8.25,8.25,0,0,0-6.08,2.42A8.79,8.79,0,0,0,44.13,34a9.15,9.15,0,0,0,2.49,6.61,8.33,8.33,0,0,0,5.82,2.22,10.76,10.76,0,0,0,7.91-3.53v7.12A15.08,15.08,0,0,1,52,48.62c-4.58,0-7.85-1.31-10.46-4A14.32,14.32,0,0,1,37.6,34.24a14.71,14.71,0,0,1,4.18-10.66c2.16-2.15,5.62-4,11-4a14.85,14.85,0,0,1,7.52,2Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M65.49,20.25H71.9v2.49a11.13,11.13,0,0,1,2.68-2.29,7.38,7.38,0,0,1,3.92-.92,9.5,9.5,0,0,1,5,1.31l-2.62,5.82a5.75,5.75,0,0,0-3.27-1,5,5,0,0,0-4,1.5c-1.77,1.9-1.77,4.51-1.77,6.34V47.77H65.49Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M113.87,34a14.71,14.71,0,0,1-29.42,0c0-8.49,6.41-14.51,14.71-14.51S113.87,25.55,113.87,34Zm-6.54.07c0-6.28-4.12-8.83-8.17-8.83S91,27.83,91,34.11c0,5.29,3.14,8.76,8.17,8.76S107.33,39.4,107.33,34.11Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M138.64,63.14v-6.4h-124v6.4Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M4.67,72.7V65.79h10V72.7Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M138.64,72.7V65.79h10V72.7Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M138.64,81.76V75.35h-124v6.41Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M14.67,85h6.41V53.54H14.67Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
    <path
      d="M132.24,85h6.4V53.54h-6.4Z"
      transform="translate(-4.67 -4.35)"
      fill="#d55772"
    />
  </svg>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style scoped></style>
